/** The `code` from the API body `{ detail: { code } }`, or null. */
export async function apiErrorCode(response: Response): Promise<string | null> {
  try {
    const body = (await response.json()) as { detail?: { code?: unknown } };
    const code = body.detail?.code;
    return typeof code === 'string' ? code : null;
  } catch {
    return null;
  }
}
